import { render, staticRenderFns } from "./PackUpsell.vue?vue&type=template&id=0eb4a43a&scoped=true"
import script from "./PackUpsell.vue?vue&type=script&lang=js"
export * from "./PackUpsell.vue?vue&type=script&lang=js"
import style0 from "./PackUpsell.vue?vue&type=style&index=0&id=0eb4a43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4a43a",
  null
  
)

export default component.exports